import { memo, useEffect, useState, useRef } from "react"
import { ScrollArea } from "@chakra-ui/react"
import ProductService from "@/services/product"
import { Stack, Alert, CloseButton, Image, EmptyState, Center, Button, Box, Text, AspectRatio, Input, Card, VStack, HStack, Separator, Heading, Flex } from "@chakra-ui/react"

import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"

import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"

import CtvService from "services/ctv"
import { useNavigate, useParams, useSearchParams } from "react-router"
import { Grid, GridItem } from "@chakra-ui/react"
import WithLoginPage from "@/components/withlogin"
import moment from "moment";
import { useAuth } from "contexts/auth";
import { useStore } from "contexts/store";
import Withdraw from "./Withdraw"
import Share from "./Share"
import { FaShare } from "react-icons/fa"
import ProductShare from "pages/product/Share"
import _ from "lodash"
import ProductItem from "./ProductItem"
const service = new CtvService();

const ProductBlock = () => {

    const { setProcessing, setPageTitle, showToast } = useApp();
    const [profile, setProfile] = useState({ order_list: [] })
    const { user } = useAuth();
    const [showShare, setShowShare] = useState(false);
    const { copyText } = useApp();
    const { store } = useStore();

    const [products, setProducts] = useState([])
    const [productID, setProductID] = useState("")
    useEffect(() => {
        setPageTitle("Sản phẩm tiếp thị")
    }, [setPageTitle])

    const navigate = useNavigate();

    useEffect(() => {

        load();
    }, [])


    const load = async () => {
        setProcessing(true);
        var a = await service.productList();
        setProducts(a);
        setProcessing(false);
    }

    const shareProduct = (id) => {
        setProductID(id)
        setShowShare(true)
    }
    return (


        <>

            <Stack separator={<Separator />}>


                {products.map(x => <ProductItem data={x} showShare={e => shareProduct(x.id)}></ProductItem>)}

            </Stack>


            <ProductShare open={showShare} id={productID} onOpenChange={e => setShowShare(false)} ></ProductShare>

        </>
    )


}










export default memo(ProductBlock)